// constellation-directory.js
(function() {
  'use strict';
  
  class PractitionerDirectory {
    constructor() {
      this.practitioners = [];
      this.filteredPractitioners = [];
      this.filters = {
        search: '',
        specialty: '',
        location: '',
        format: ''
      };
      this.sortBy = 'name';
      
      this.init();
    }
    
    async init() {
      this.bindEvents();
      await this.loadData();
      this.filteredPractitioners = [...this.practitioners];
      this.updateStats();
      this.render();
    }
    
    async loadData() {
      try {
        console.log('Loading data from Google Sheets...');
        
        const sheetId = '14Fiiq8rBv0MVQYhK1L26iZuRFdfvf9V1BKXhpZsLaic';
        
        // Try different URL formats
        const urlFormats = [
          `https://docs.google.com/spreadsheets/d/${sheetId}/export?format=csv&gid=531441240`,
          `https://docs.google.com/spreadsheets/d/${sheetId}/export?format=csv`
        ];
        
        let csvText = '';
        let success = false;
        
        for (const csvUrl of urlFormats) {
          try {
            console.log('Trying URL:', csvUrl);
            const response = await fetch(csvUrl);
            if (response.ok) {
              csvText = await response.text();
              console.log('Success with URL:', csvUrl);
              success = true;
              break;
            }
          } catch (err) {
            console.log('Failed with URL:', csvUrl);
          }
        }
        
        if (!success) {
          throw new Error('Could not fetch CSV data');
        }
        
        // Clean and parse CSV
        csvText = csvText.trim();
        console.log('CSV sample:', csvText.substring(0, 500));
        
        // Parse data
        this.parseCSVData(csvText);
        
        console.log(`✅ Loaded ${this.practitioners.length} practitioners`);
        
        this.populateFilters();
        this.hideLoading();
        
      } catch (error) {
        console.error('Error:', error);
        this.showError(error.message);
      }
    }
    
    parseCSVData(csvText) {
      try {
        // Split lines properly
        const lines = [];
        let currentLine = '';
        let inQuotes = false;
        
        for (let i = 0; i < csvText.length; i++) {
          const char = csvText[i];
          const nextChar = csvText[i + 1];
          
          if (char === '"' && !inQuotes) {
            inQuotes = true;
            currentLine += char;
          } else if (char === '"' && inQuotes) {
            if (nextChar === '"') {
              currentLine += '""';
              i++;
            } else {
              inQuotes = false;
              currentLine += char;
            }
          } else if (char === '\n' && !inQuotes) {
            lines.push(currentLine);
            currentLine = '';
          } else if (char === '\r' && nextChar === '\n' && !inQuotes) {
            lines.push(currentLine);
            currentLine = '';
            i++;
          } else {
            currentLine += char;
          }
        }
        
        if (currentLine) lines.push(currentLine);
        
        console.log('Total lines:', lines.length);
        
        // Get headers from first line
        const headers = this.parseCSVLine(lines[0]);
        console.log('Headers:', headers);
        
        this.practitioners = [];
        
        // Process each row
        for (let i = 1; i < lines.length; i++) {
          if (!lines[i].trim()) continue;
          
          const values = this.parseCSVLine(lines[i]);
          
          if (values.length >= headers.length) {
            const rowData = {};
            headers.forEach((header, index) => {
              rowData[header] = values[index] || '';
            });
            
            // Check permission
            const permissionField = rowData['10. Permission to Publish'] || '';
            const confirmationField = rowData['11. Confirmation'] || '';
            
            const hasPermission = permissionField.toLowerCase().includes('permission to publish');
            const hasConfirmation = confirmationField.toLowerCase().includes('confirm');
            
            if (hasPermission && hasConfirmation) {
              const practitioner = {
                fullName: rowData['1. Full Name + Credentials'] || '',
                clinicName: rowData['2. Practice / Clinic Name'] || '',
                location: rowData['3. Location'] || '',
                specialty: rowData['4. Specialty'] || '',
                careFormat: this.formatCareFormat(rowData['5. Care Format'] || ''),
                website: this.cleanWebsite(rowData['6. Website or Booking Link'] || ''),
                bio: rowData['7. Short Bio'] || '',
                quote: rowData['8. Quote About Steaming and the LEIAMOON Steam Seat'] || '',
                headshot: this.processHeadshotLink(rowData['9. Headshot Upload'] || ''),
                timestamp: rowData['Timestamp'] || '',
                email: rowData['Email Address'] || ''
              };
              
              console.log(`✅ Added: ${practitioner.fullName}`);
              console.log(`   Headshot URL: ${practitioner.headshot}`);
              
              this.practitioners.push(practitioner);
            } else {
              console.log(`❌ Skipped - No permission: ${rowData['1. Full Name + Credentials']}`);
            }
          }
        }
        
      } catch (error) {
        console.error('Parse error:', error);
        throw error;
      }
    }
    
    parseCSVLine(line) {
      const result = [];
      let current = '';
      let inQuotes = false;
      
      for (let i = 0; i < line.length; i++) {
        const char = line[i];
        const nextChar = line[i + 1];
        
        if (char === '"' && !inQuotes) {
          inQuotes = true;
        } else if (char === '"' && inQuotes) {
          if (nextChar === '"') {
            current += '"';
            i++;
          } else {
            inQuotes = false;
          }
        } else if (char === ',' && !inQuotes) {
          result.push(current);
          current = '';
        } else {
          current += char;
        }
      }
      
      result.push(current);
      
      return result.map(field => {
        field = field.trim();
        if (field.startsWith('"') && field.endsWith('"')) {
          field = field.substring(1, field.length - 1);
        }
        return field.replace(/""/g, '"');
      });
    }
    
    cleanWebsite(url) {
      if (!url) return '';
      url = url.trim();
      
      // Remove quotes
      url = url.replace(/^["']|["']$/g, '');
      
      if (!url) return '';
      
      if (url.startsWith('http://') || url.startsWith('https://')) {
        return url;
      }
      
      if (url.toLowerCase().startsWith('www.')) {
        return 'https://' + url;
      }
      
      if (url.includes('.') && !url.includes(' ')) {
        return 'https://www.' + url;
      }
      
      return url;
    }
    
    processHeadshotLink(link) {
      if (!link) return '';
      
      link = link.trim();
      
      // If it's already a direct image URL, return it
      if (link.match(/\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i)) {
        return link;
      }
      
      // Handle Google Drive links
      if (link.includes('drive.google.com')) {
        // Extract file ID
        const fileIdMatch = link.match(/[-\w]{25,}/);
        if (fileIdMatch) {
          const fileId = fileIdMatch[0];
          // Use this format for direct image access
          return `https://lh3.googleusercontent.com/d/${fileId}=s400?authuser=0`;
        }
      }
      
      // If it's a Google Drive view link, try to convert it
      if (link.includes('drive.google.com/open')) {
        const idMatch = link.match(/id=([\w-]+)/);
        if (idMatch) {
          return `https://lh3.googleusercontent.com/d/${idMatch[1]}=s400?authuser=0`;
        }
      }
      
      return link;
    }
    
    formatCareFormat(format) {
      if (!format) return 'Not specified';
      
      format = format.toLowerCase().trim();
      
      if (format.includes('both') || (format.includes('in-person') && format.includes('virtual'))) {
        return 'Both';
      }
      if (format.includes('virtual')) {
        return 'Virtual';
      }
      if (format.includes('in-person')) {
        return 'In-person';
      }
      
      return format.charAt(0).toUpperCase() + format.slice(1);
    }
    
    populateFilters() {
      console.log('Populating filters...');
      
      const specialties = new Set();
      const locations = new Set();
      
      this.practitioners.forEach(p => {
        if (p.specialty) {
          p.specialty.split(/[,•·\n]/).forEach(s => {
            const trimmed = s.trim();
            if (trimmed) specialties.add(trimmed);
          });
        }
        
        if (p.location) {
          const loc = p.location.split(',')[0].trim();
          if (loc) locations.add(loc);
        }
      });
      
      // Specialty filter
      const specialtyFilter = document.getElementById('filter-specialty');
      if (specialtyFilter) {
        Array.from(specialties).sort().forEach(specialty => {
          const option = document.createElement('option');
          option.value = specialty;
          option.textContent = specialty;
          specialtyFilter.appendChild(option);
        });
      }
      
      // Location filter
      const locationFilter = document.getElementById('filter-location');
      if (locationFilter) {
        Array.from(locations).sort().forEach(location => {
          const option = document.createElement('option');
          option.value = location;
          option.textContent = location;
          locationFilter.appendChild(option);
        });
      }
    }
    
    bindEvents() {
      // Search
      document.getElementById('search-practitioners')?.addEventListener('input', (e) => {
        this.filters.search = e.target.value.toLowerCase();
        this.applyFilters();
      });
      
      // Filters
      document.getElementById('filter-specialty')?.addEventListener('change', (e) => {
        this.filters.specialty = e.target.value;
        this.applyFilters();
      });
      
      document.getElementById('filter-location')?.addEventListener('change', (e) => {
        this.filters.location = e.target.value;
        this.applyFilters();
      });
      
      document.getElementById('filter-format')?.addEventListener('change', (e) => {
        this.filters.format = e.target.value;
        this.applyFilters();
      });
      
      // Sort
      document.getElementById('sort-by')?.addEventListener('change', (e) => {
        this.sortBy = e.target.value;
        this.applyFilters();
      });
      
      // Clear filters
      document.getElementById('clear-filters')?.addEventListener('click', () => {
        this.clearFilters();
      });
      
      document.getElementById('reset-filters')?.addEventListener('click', () => {
        this.clearFilters();
      });
    }
    
    applyFilters() {
      this.filteredPractitioners = this.practitioners.filter(p => {
        // Search
        if (this.filters.search) {
          const searchText = [p.fullName, p.clinicName, p.location, p.specialty, p.bio]
            .join(' ')
            .toLowerCase();
          if (!searchText.includes(this.filters.search)) return false;
        }
        
        // Specialty
        if (this.filters.specialty && !p.specialty.toLowerCase().includes(this.filters.specialty.toLowerCase())) {
          return false;
        }
        
        // Location
        if (this.filters.location) {
          const mainLocation = p.location ? p.location.split(',')[0].trim() : '';
          if (mainLocation !== this.filters.location) return false;
        }
        
        // Format
        if (this.filters.format && p.careFormat !== this.filters.format) {
          return false;
        }
        
        return true;
      });
      
      this.sortPractitioners();
      this.updateStats();
      this.render();
    }
    
    sortPractitioners() {
      this.filteredPractitioners.sort((a, b) => {
        switch (this.sortBy) {
          case 'name': return (a.fullName || '').localeCompare(b.fullName || '');
          case 'location': 
            const locA = a.location ? a.location.split(',')[0].trim() : '';
            const locB = b.location ? b.location.split(',')[0].trim() : '';
            return locA.localeCompare(locB);
          case 'specialty': return (a.specialty || '').localeCompare(b.specialty || '');
          default: return 0;
        }
      });
    }
    
    updateStats() {
      document.getElementById('total-count').textContent = this.practitioners.length;
      document.getElementById('showing-count').textContent = this.filteredPractitioners.length;
      
      // Count locations
      const locations = new Set();
      this.practitioners.forEach(p => {
        if (p.location) {
          const loc = p.location.split(',')[0].trim();
          if (loc) locations.add(loc);
        }
      });
      document.getElementById('countries-count').textContent = locations.size;
      
      // Count specialties
      const specialties = new Set();
      this.practitioners.forEach(p => {
        if (p.specialty) {
          p.specialty.split(/[,•·\n]/).forEach(s => {
            const trimmed = s.trim();
            if (trimmed) specialties.add(trimmed);
          });
        }
      });
      document.getElementById('specialties-count').textContent = specialties.size;
    }
    
    clearFilters() {
      this.filters = { search: '', specialty: '', location: '', format: '' };
      
      document.getElementById('search-practitioners').value = '';
      document.getElementById('filter-specialty').value = '';
      document.getElementById('filter-location').value = '';
      document.getElementById('filter-format').value = '';
      document.getElementById('sort-by').value = 'name';
      
      this.filteredPractitioners = [...this.practitioners];
      this.updateStats();
      this.render();
    }
    
    render() {
      const grid = document.getElementById('practitioner-grid');
      const noResults = document.getElementById('no-results');
      const loading = document.getElementById('loading-container');
      
      if (loading) loading.style.display = 'none';
      
      if (this.filteredPractitioners.length === 0) {
        if (grid) grid.innerHTML = '';
        if (noResults) noResults.style.display = 'block';
        return;
      }
      
      if (noResults) noResults.style.display = 'none';
      
      const cardsHTML = this.filteredPractitioners.map(p => this.createCardHTML(p)).join('');
      if (grid) {
        grid.innerHTML = cardsHTML;
        console.log(`Rendered ${this.filteredPractitioners.length} cards`);
      }
    }
    
    createCardHTML(practitioner) {
      const formatClass = practitioner.careFormat ? 
        `format-${practitioner.careFormat.toLowerCase().replace(/\s+/g, '-')}` : 
        'format-not-specified';
      
      const formatText = practitioner.careFormat === 'Both' ? 
        'In-person & Virtual' : 
        (practitioner.careFormat || 'Not specified');
      
      // Test the image URL
      if (practitioner.headshot) {
        console.log(`Image URL for ${practitioner.fullName}:`, practitioner.headshot);
      }
      
      return `
        <div class="practitioner-card">
          <div class="card-header">
            <div class="verified-badge">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
              </svg>
              Verified
            </div>
            
            ${practitioner.headshot ? `
              <div class="profile-image-container">
                <img src="${this.escapeHTML(practitioner.headshot)}" 
                     alt="${this.escapeHTML(practitioner.fullName)}"
                     class="profile-image"
                     loading="lazy"
                     onerror="this.onerror=null; this.src='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iNjAiIGN5PSI2MCIgcj0iNjAiIGZpbGw9IiM4QjVDRkYiLz48dGV4dCB4PSI1MCUiIHk9IjUwJSIgZG9taW5hbnQtYmFzZWxpbmU9Im1pZGRsZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiIGZvbnQtc2l6ZT0iNDgiIGZvbnQtd2VpZ2h0PSJib2xkIj5MPC90ZXh0Pjwvc3ZnPg=='">
              </div>
            ` : `
              <div class="profile-image-container">
                <div class="default-avatar">${(practitioner.fullName || 'L').charAt(0)}</div>
              </div>
            `}
            
            <h2 class="practitioner-name">${this.escapeHTML(practitioner.fullName)}</h2>
            
            ${practitioner.clinicName ? `
              <div class="clinic-name">
                ${this.escapeHTML(practitioner.clinicName)}
              </div>
            ` : ''}
          </div>
          
          <div class="card-body">
            <div class="info-grid">
              ${practitioner.location ? `
                <div class="info-item location-item">
                  <div class="info-icon"></div>
                  <div class="info-content">
                    <div class="info-label">Location</div>
                    <div class="info-value">${this.escapeHTML(practitioner.location)}</div>
                  </div>
                </div>
              ` : ''}
              
              ${practitioner.specialty ? `
                <div class="info-item specialty-item">
                  <div class="info-icon"></div>
                  <div class="info-content">
                    <div class="info-label">Specialty</div>
                    <div class="info-value">${this.escapeHTML(practitioner.specialty)}</div>
                  </div>
                </div>
              ` : ''}
              
              <div class="info-item format-item">
                <div class="info-icon"></div>
                <div class="info-content">
                  <div class="info-label">Care Format</div>
                  <div class="format-badges">
                    <span class="format-badge ${formatClass}">${formatText}</span>
                  </div>
                </div>
              </div>
            </div>
            
            ${practitioner.bio ? `
              <div class="bio-section">
                <div class="bio-label">Professional Bio</div>
                <div class="bio-text">${this.escapeHTML(practitioner.bio)}</div>
              </div>
            ` : ''}
            
            ${practitioner.quote ? `
              <div class="quote-section">
                <div class="quote-label">Quote About LEIAMOON</div>
                <p class="quote-text">"${this.escapeHTML(practitioner.quote)}"</p>
              </div>
            ` : ''}
          </div>
          
          <div class="card-footer">
            ${practitioner.website ? `
              <a href="${this.escapeHTML(practitioner.website)}" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 class="website-link">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
                  <polyline points="15 3 21 3 21 9"/>
                  <line x1="10" y1="14" x2="21" y2="3"/>
                </svg>
                Visit Website
              </a>
            ` : '<div></div>'}
            
            ${practitioner.timestamp ? `
              <div class="publish-date">
                Joined ${new Date(practitioner.timestamp).toLocaleDateString('en-US', { 
                  month: 'long', 
                  year: 'numeric' 
                })}
              </div>
            ` : ''}
          </div>
        </div>
      `;
    }
    
    escapeHTML(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }
    
    hideLoading() {
      document.getElementById('loading-container').style.display = 'none';
    }
    
    showError(message) {
      const grid = document.getElementById('practitioner-grid');
      if (grid) {
        grid.innerHTML = `
          <div class="error-message" style="grid-column: 1/-1; text-align: center; padding: 60px 20px;">
            <h3 style="color: #dc2626; margin-bottom: 20px;">Error Loading Data</h3>
            <p style="color: #6b7280; margin-bottom: 20px;">${message}</p>
            <p style="color: #6b7280; font-size: 0.9rem;">
              Please check your Google Sheet is published to web as CSV.
            </p>
          </div>
        `;
      }
      this.hideLoading();
    }
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    new PractitionerDirectory();
  });
})();